export const REALTIME_INTERVAL_MINUTES = 3;
export const REALTIME_POLLING_MS = REALTIME_INTERVAL_MINUTES * 60 * 1000;

export const REALTIME_SLOTS = 12;
